<template>
  <div class="footer">
    <div class="footer-content">
      <div class="border"></div>
      <div class="container">
        <p class="copyright"> 
          <font-awesome-icon icon="copyright" /> 
          <span class="year">{{ currentYear}} </span> |
          <span class="title">
          Freiwillige Feuerwehr Pfaffenhofen.
            </span> 
        </p>
        <div class="social-media">
          <a href="https://www.facebook.com/Feuerwehr-Pfaffenhofen-an-der-Roth-109956954593455/"><i class="fab fa-facebook"></i></a>
          <span class="seperator"> &bull; </span>
          <a href="https://www.instagram.com/ffpfaffenhofen/"><i class="fab fa-instagram"></i></a>
        </div>
      </div>
      <div class="legal">
        <div class="container">
          <p>
            <span class="entry" @click="showImpressum()">Impressum</span> 
            <span class="seperator"> &bull; </span>
            <span class="entry" @click="showPrivacy()">Datenschutz</span> 
            <span class="seperator"> &bull; </span>
            <span class="entry" v-scroll-to="{ element: '#contact', duration: 500 }">Kontakt</span> 
          </p>
        </div>
      </div>
      <div class="container other">
        <div class="flex-row">
          <div class="links">
            <p class="header">Feuerwehr Pfaffenhofen</p>
            <div class="link-list">
              <div class="link">
                <router-link to="einsatz">Einsätze</router-link>
              </div>
              <div class="link">
                <router-link to="aktuelles">Neuigkeiten und Aktuelles</router-link>
              </div>
              <div class="link">
                <router-link to="/#contact">Kontakt</router-link>
              </div>
              <div class="link">
                <router-link to="fahrzeug">Fahrzeuge</router-link>
              </div>
              <div class="link">
                <router-link to="group">Mannschaft</router-link>
              </div>
              <div class="link">
                <router-link to="jugend">Jugendgruppe</router-link>
              </div>
              <div class="link">
                <router-link to="standort">Standort</router-link>
              </div>
            </div>
          </div>
          <div class="links-others">
            <p class="header">Partner und andere Links</p>
            <div class="link-list">
              <div class="link">
                <a href="http://www.markt-pfaffenhofen.de/">Marktgemeinde Pfaffenhofen</a>
              </div>
              <div class="link">
                <a href="http://www.kfv-nu.de/">Kreisfeuerwehrverband Neu-Ulm</a>
              </div>
              <div class="link">
                <a href="https://www.bfv-schwaben.org/">Bezirksfeuerwehrverband Schwaben</a>
              </div>
              <div class="link">
                <a href="https://www.lfv-bayern.de/">Landesfeuerwehrverband Bayern</a>
              </div>
              <div class="link">
                <a href="http://www.feuerwehrverband.de/">Deutscher Feuerwehrverband</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal name="impressum-modal" :pivotY=0.12 height="auto" :adaptive="true" width="950px"> 
      <div class="impressum-modal modal">
        <h1>Impressum</h1>
        <p><b>Angaben gemäß § 5 TMG</b></p>
        <p>
          Freiwillige Feuerwehr Pfaffenhofen e. V. <br>
          Friedhofweg 1 <br>
          89284 Pfaffenhofen
        </p>
        <p>
          Telefon: +49 7302 6288  <b>(kein Notruf!)</b> <br>
          E-Mail: 
          <a class="entry" href="mailto:briefkasten@ff-pfaffenhofen.de">
            <i>briefkasten@ff-pfaffenhofen.de</i>
          </a>
        </p>
        <p>
          Vertretungsberechtigter Vorstand: Christian Lindstedt <br>
          Registergericht: Amtsgericht Neu-Ulm <br>
          Registernummer: VR 500 <br>
          Inhaltlich Verantwortlicher gemäß § 10 Absatz 3 MDStV: 1. 
          Kommandant Torsten Schmucker
        </p>
        <h2>Haftungsausschluss: </h2>
        <p><b>Haftung für Inhalte</b></p>
        <p>
          Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt.
          Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte 
          können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter 
          sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
          nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG 
          sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte 
          oder gespeicherte fremde Informationen zu überwachen oder nach Umständen 
          zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. 
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von 
          Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. 
          Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis 
          einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von 
          entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend 
          entfernen.
        </p>
        <p><b>Haftung für Links</b></p>
        <p>
          Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren 
          Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden 
          Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten
           ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. 
           Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche 
           Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der 
           Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der 
           verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer 
           Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen
            werden wir derartige Links umgehend entfernen.
          </p>
          <p><b>Urheberrecht</b></p>
          <p>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen 
            Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, 
            Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen 
            es Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen
            Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für 
            den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte 
            auf dieser Seite nicht vom Betreiber erstellt wurden, werden die 
            Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter 
            als solche gekennzeichnet. Sollten Sie trotzdem auf eine 
            Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
            entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen 
            werden wir derartige Inhalte umgehend entfernen.
          </p>
      </div>
    </modal>
    <modal name="privacy-modal" :pivotY=0.12 height="auto" :adaptive="true" width="950px"> 
      <div class="privacy-modal modal">
        <h1>Datenschutzerklärung</h1>
        <p class="small">
          Diese Datenschutzerklärung klärt Sie über die Art, den Umfang und 
          Zweck der Verarbeitung von personenbezogenen Daten (nachfolgend kurz „Daten“) 
          innerhalb unseres Onlineangebotes und der mit ihm verbundenen Webseiten, 
          Funktionen und Inhalte sowie externen Onlinepräsenzen, wie z.B. unser Social 
          Media Profile auf (nachfolgend gemeinsam bezeichnet als „Onlineangebot“). 
          Im Hinblick auf die verwendeten Begrifflichkeiten, wie z.B. „Verarbeitung“
           oder „Verantwortlicher“ verweisen wir auf die Definitionen im Art. 4 der 
           Datenschutzgrundverordnung (DSGVO).
        </p>
        <p><b>Verantwortlicher</b></p>
        <p class="small">
          Freiwillige Feuerwehr Pfaffenhofen e. V. <br>
          Friedhofweg 1 <br>
          89284 Pfaffenhofen <br>
          Telefon: +49 7302 6288 <b>(kein Notruf!)</b> <br>
          E-Mail:  
          <a class="entry" href="mailto:briefkasten@ff-pfaffenhofen.de">
            <i>briefkasten@ff-pfaffenhofen.de</i>
          </a> <br><br>
          Vertretungsberechtigter Vorstand: Christian Lindstedt <br>
          Registergericht: Amtsgericht Neu-Ulm <br>
          Registernummer: VR 500 <br>
        </p>
        <p><b>Arten der verarbeiteten Daten</b></p>
        <p class="small">
          Bestandsdaten (z.B., Namen, Adressen). <br>
          Kontaktdaten (z.B., E-Mail, Telefonnummern). <br>
          Inhaltsdaten (z.B., Texteingaben, Fotografien, Videos). <br>
          Nutzungsdaten (z.B., besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten). <br>
          Meta-/Kommunikationsdaten (z.B., Geräte-Informationen, IP-Adressen). <br>
        </p>
        <p><b>Zweck der Verarbeitung</b></p>
        <p class="small">
          Zurverfügungstellung des Onlineangebotes, seiner Funktionen und Inhalte. <br>
          Beantwortung von Kontaktanfragen und Kommunikation mit Nutzern. <br>
          Sicherheitsmaßnahmen. <br>
          Reichweitenmessung/Marketing
        </p>
        <p><b>Verwendete Begrifflichkeiten </b></p>
        <p class="small">
          „Personenbezogene Daten“ sind alle Informationen, die sich auf eine 
          identifizierte oder identifizierbare natürliche Person (im Folgenden 
          „betroffene Person“) beziehen; als identifizierbar wird eine natürliche 
          Person angesehen, die direkt oder indirekt, insbesondere mittels Zuordnung
          zu einer Kennung wie einem Namen, zu einer Kennnummer, zu Standortdaten, 
          zu einer Online-Kennung (z.B. Cookie) oder zu einem oder mehreren besonderen
          Merkmalen identifiziert werden kann, die Ausdruck der physischen, 
          physiologischen, genetischen, psychischen, wirtschaftlichen, kulturellen 
          oder sozialen Identität dieser natürlichen Person sind. <br>
          „Verarbeitung“ ist jeder mit oder ohne Hilfe automatisierter 
          Verfahren ausgeführte Vorgang oder jede solche Vorgangsreihe im 
          Zusammenhang mit personenbezogenen Daten. Der Begriff reicht weit 
          und umfasst praktisch jeden Umgang mit Daten. <br>
          „Pseudonymisierung“ die Verarbeitung personenbezogener Daten in einer 
          Weise, dass die personenbezogenen Daten ohne Hinzuziehung zusätzlicher 
          Informationen nicht mehr einer spezifischen betroffenen Person zugeordnet 
          werden können, sofern diese zusätzlichen Informationen gesondert aufbewahrt
           werden und technischen und organisatorischen Maßnahmen unterliegen, die 
           gewährleisten, dass die personenbezogenen Daten nicht einer 
           identifizierten oder identifizierbaren natürlichen Person zugewiesen 
           werden. <br>
          „Profiling“ jede Art der automatisierten Verarbeitung personenbezogener
           Daten, die darin besteht, dass diese personenbezogenen Daten verwendet
          werden, um bestimmte persönliche Aspekte, die sich auf eine natürliche
          Person beziehen, zu bewerten, insbesondere um Aspekte bezüglich 
          Arbeitsleistung, wirtschaftliche Lage, Gesundheit, persönliche 
          Vorlieben, Interessen, Zuverlässigkeit, Verhalten, Aufenthaltsort 
          oder Ortswechsel dieser natürlichen Person zu analysieren oder 
          vorherzusagen. <br>
          Als „Verantwortlicher“ wird die natürliche oder juristische Person, 
          Behörde, Einrichtung oder andere Stelle, die allein oder gemeinsam mit 
          anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen
           Daten entscheidet, bezeichnet. <br>
          „Auftragsverarbeiter“ eine natürliche oder juristische Person, Behörde,
          Einrichtung oder andere Stelle, die personenbezogene Daten im Auftrag des
          Verantwortlichen verarbeitet. <br>
        </p>
        <p><b>Maßgebliche Rechtsgrundlagen</b></p>
        <p class="small">Nach Maßgabe des Art. 13 DSGVO teilen wir Ihnen die Rechtsgrundlagen unserer Datenverarbeitungen mit. Sofern die Rechtsgrundlage in der Datenschutzerklärung nicht genannt wird, gilt Folgendes: Die Rechtsgrundlage für die Einholung von Einwilligungen ist Art. 6 Abs. 1 lit. a und Art. 7 DSGVO, die Rechtsgrundlage für die Verarbeitung zur Erfüllung unserer Leistungen und Durchführung vertraglicher Maßnahmen sowie Beantwortung von Anfragen ist Art. 6 Abs. 1 lit. b DSGVO, die Rechtsgrundlage für die Verarbeitung zur Erfüllung unserer rechtlichen Verpflichtungen ist Art. 6 Abs. 1 lit. c DSGVO, und die Rechtsgrundlage für die Verarbeitung zur Wahrung unserer berechtigten Interessen ist Art. 6 Abs. 1 lit. f DSGVO. Für den Fall, dass lebenswichtige Interessen der betroffenen Person oder einer anderen natürlichen Person eine Verarbeitung personenbezogener Daten erforderlich machen, dient Art. 6 Abs. 1 lit. d DSGVO als Rechtsgrundlage.</p>
        <p><b>Sicherheitsmaßnahmen</b></p>
        <p class="small">
          Wir treffen nach Maßgabe des Art. 32 DSGVO unter Berücksichtigung des Stands der Technik, der Implementierungskosten und der Art, des Umfangs, der Umstände und der Zwecke der Verarbeitung sowie der unterschiedlichen Eintrittswahrscheinlichkeit und Schwere des Risikos für die Rechte und Freiheiten natürlicher Personen, geeignete technische und organisatorische Maßnahmen, um ein dem Risiko angemessenes Schutzniveau zu gewährleisten. <br>
          Zu den Maßnahmen gehören insbesondere die Sicherung der Vertraulichkeit, Integrität und Verfügbarkeit von Daten durch Kontrolle des physischen Zugangs zu den Daten, als auch des sie betreffenden Zugriffs, der Eingabe, Weitergabe, der Sicherung der Verfügbarkeit und ihrer Trennung. Des Weiteren haben wir Verfahren eingerichtet, die eine Wahrnehmung von Betroffenenrechten, Löschung von Daten und Reaktion auf Gefährdung der Daten gewährleisten. Ferner berücksichtigen wir den Schutz personenbezogener Daten bereits bei der Entwicklung, bzw. Auswahl von Hardware, Software sowie Verfahren, entsprechend dem Prinzip des Datenschutzes durch Technikgestaltung und durch datenschutzfreundliche Voreinstellungen (Art. 25 DSGVO).</p>
        <p><b>Zusammenarbeit mit Auftragsverarbeitern und Dritten</b></p>
        <p class="small">
        Sofern wir im Rahmen unserer Verarbeitung Daten gegenüber anderen Personen und Unternehmen (Auftragsverarbeitern oder Dritten) offenbaren, sie an diese übermitteln oder ihnen sonst Zugriff auf die Daten gewähren, erfolgt dies nur auf Grundlage einer gesetzlichen Erlaubnis (z.B. wenn eine Übermittlung der Daten an Dritte, wie an Zahlungsdienstleister, gem. Art. 6 Abs. 1 lit. b DSGVO zur Vertragserfüllung erforderlich ist), Sie eingewilligt haben, eine rechtliche Verpflichtung dies vorsieht oder auf Grundlage unserer berechtigten Interessen (z.B. beim Einsatz von Beauftragten, Webhostern, etc.). <br>
        Sofern wir Dritte mit der Verarbeitung von Daten auf Grundlage eines sog. „Auftragsverarbeitungsvertrages“ beauftragen, geschieht dies auf Grundlage des Art. 28 DSGVO.</p>
        <p><b>Übermittlungen in Drittländer</b></p>
        <p class="small">Sofern wir Daten in einem Drittland (d.h. außerhalb der Europäischen Union (EU) oder des Europäischen Wirtschaftsraums (EWR)) verarbeiten oder dies im Rahmen der Inanspruchnahme von Diensten Dritter oder Offenlegung, bzw. Übermittlung von Daten an Dritte geschieht, erfolgt dies nur, wenn es zur Erfüllung unserer (vor)vertraglichen Pflichten, auf Grundlage Ihrer Einwilligung, aufgrund einer rechtlichen Verpflichtung oder auf Grundlage unserer berechtigten Interessen geschieht. Vorbehaltlich gesetzlicher oder vertraglicher Erlaubnisse, verarbeiten oder lassen wir die Daten in einem Drittland nur beim Vorliegen der besonderen Voraussetzungen der Art. 44 ff. DSGVO verarbeiten. D.h. die Verarbeitung erfolgt z.B. auf Grundlage besonderer Garantien, wie der offiziell anerkannten Feststellung eines der EU entsprechenden Datenschutzniveaus (z.B. für die USA durch das „Privacy Shield“) oder Beachtung offiziell anerkannter spezieller vertraglicher Verpflichtungen (so genannte „Standardvertragsklauseln“).</p>
        <p><b>Rechte der betroffenen Personen</b></p>
        <p class="small">Sie haben das Recht, eine Bestätigung darüber zu verlangen, ob betreffende Daten verarbeitet werden und auf Auskunft über diese Daten sowie auf weitere Informationen und Kopie der Daten entsprechend Art. 15 DSGVO. <br>
          Sie haben entsprechend. Art. 16 DSGVO das Recht, die Vervollständigung der Sie betreffenden Daten oder die Berichtigung der Sie betreffenden unrichtigen Daten zu verlangen. <br>
          Sie haben nach Maßgabe des Art. 17 DSGVO das Recht zu verlangen, dass betreffende Daten unverzüglich gelöscht werden, bzw. alternativ nach Maßgabe des Art. 18 DSGVO eine Einschränkung der Verarbeitung der Daten zu verlangen. <br>
          Sie haben das Recht zu verlangen, dass die Sie betreffenden Daten, die Sie uns bereitgestellt haben nach Maßgabe des Art. 20 DSGVO zu erhalten und deren Übermittlung an andere Verantwortliche zu fordern. <br>
          Sie haben ferner gem. Art. 77 DSGVO das Recht, eine Beschwerde bei der zuständigen Aufsichtsbehörde einzureichen.</p>
        <p><b>Widerrufsrecht</b></p>
        <p class="small">Sie haben das Recht, erteilte Einwilligungen gem. Art. 7 Abs. 3 DSGVO mit Wirkung für die Zukunft zu widerrufen</p>
        <p><b>Widerspruchsrecht</b></p>
        <p class="small">Sie können der künftigen Verarbeitung der Sie betreffenden Daten nach Maßgabe des Art. 21 DSGVO jederzeit widersprechen. Der Widerspruch kann insbesondere gegen die Verarbeitung für Zwecke der Direktwerbung erfolgen.</p>
        <p><b>Cookies und Widerspruchsrecht bei Direktwerbung</b></p>
        <p class="small">
          Als „Cookies“ werden kleine Dateien bezeichnet, die auf Rechnern der Nutzer gespeichert werden. Innerhalb der Cookies können unterschiedliche Angaben gespeichert werden. Ein Cookie dient primär dazu, die Angaben zu einem Nutzer (bzw. dem Gerät auf dem das Cookie gespeichert ist) während oder auch nach seinem Besuch innerhalb eines Onlineangebotes zu speichern. Als temporäre Cookies, bzw. „Session-Cookies“ oder „transiente Cookies“, werden Cookies bezeichnet, die gelöscht werden, nachdem ein Nutzer ein Onlineangebot verlässt und seinen Browser schließt. In einem solchen Cookie kann z.B. der Inhalt eines Warenkorbs in einem Onlineshop oder ein Login-Status gespeichert werden. Als „permanent“ oder „persistent“ werden Cookies bezeichnet, die auch nach dem Schließen des Browsers gespeichert bleiben. So kann z.B. der Login-Status gespeichert werden, wenn die Nutzer diese nach mehreren Tagen aufsuchen. Ebenso können in einem solchen Cookie die Interessen der Nutzer gespeichert werden, die für Reichweitenmessung oder Marketingzwecke verwendet werden. Als „Third-Party-Cookie“ werden Cookies bezeichnet, die von anderen Anbietern als dem Verantwortlichen, der das Onlineangebot betreibt, angeboten werden (andernfalls, wenn es nur dessen Cookies sind spricht man von „First-Party Cookies“). <br>
          Wir können temporäre und permanente Cookies einsetzen und klären hierüber im Rahmen unserer Datenschutzerklärung auf. <br>
          Falls die Nutzer nicht möchten, dass Cookies auf ihrem Rechner gespeichert werden, werden sie gebeten die entsprechende Option in den Systemeinstellungen ihres Browsers zu deaktivieren. Gespeicherte Cookies können in den Systemeinstellungen des Browsers gelöscht werden. Der Ausschluss von Cookies kann zu Funktionseinschränkungen dieses Onlineangebotes führen. <br>
          Ein genereller Widerspruch gegen den Einsatz der zu Zwecken des Onlinemarketing eingesetzten Cookies kann bei einer Vielzahl der Dienste, vor allem im Fall des Trackings, über die US-amerikanische Seite http://www.aboutads.info/choices/ oder die EU-Seite http://www.youronlinechoices.com/ erklärt werden. Des Weiteren kann die Speicherung von Cookies mittels deren Abschaltung in den Einstellungen des Browsers erreicht werden. Bitte beachten Sie, dass dann gegebenenfalls nicht alle Funktionen dieses Onlineangebotes genutzt werden können.
        </p>
        <p><b>Löschung von Daten</b></p>
        <p class="small">
          Die von uns verarbeiteten Daten werden nach Maßgabe der Art. 17 und 18 DSGVO gelöscht oder in ihrer Verarbeitung eingeschränkt. Sofern nicht im Rahmen dieser Datenschutzerklärung ausdrücklich angegeben, werden die bei uns gespeicherten Daten gelöscht, sobald sie für ihre Zweckbestimmung nicht mehr erforderlich sind und der Löschung keine gesetzlichen Aufbewahrungspflichten entgegenstehen. Sofern die Daten nicht gelöscht werden, weil sie für andere und gesetzlich zulässige Zwecke erforderlich sind, wird deren Verarbeitung eingeschränkt. D.h. die Daten werden gesperrt und nicht für andere Zwecke verarbeitet. Das gilt z.B. für Daten, die aus handels- oder steuerrechtlichen Gründen aufbewahrt werden müssen. <br>
          Nach gesetzlichen Vorgaben in Österreich erfolgt die Aufbewahrung insbesondere für 7 J gemäß § 132 Abs. 1 BAO (Buchhaltungsunterlagen, Belege/Rechnungen, Konten, Belege, Geschäftspapiere, Aufstellung der Einnahmen und Ausgaben, etc.), für 22 Jahre im Zusammenhang mit Grundstücken und für 10 Jahre bei Unterlagen im Zusammenhang mit elektronisch erbrachten Leistungen, Telekommunikations-, Rundfunk- und Fernsehleistungen, die an Nichtunternehmer in EU-Mitgliedstaaten erbracht werden und für die der Mini-One-Stop-Shop (MOSS) in Anspruch genommen wird. <br>
        </p>
        <p><b> Erbringung unserer satzungs- und geschäftsgemäßen Leistungen</b></p>
        <p class="small">
          Wir verarbeiten die Daten unserer Mitglieder, Unterstützer, Interessenten, Kunden oder sonstiger Personen entsprechend Art. 6 Abs. 1 lit. b. DSGVO, sofern wir ihnen gegenüber vertragliche Leistungen anbieten oder im Rahmen bestehender geschäftlicher Beziehung, z.B. gegenüber Mitgliedern, tätig werden oder selbst Empfänger von Leistungen und Zuwendungen sind. Im Übrigen verarbeiten wir die Daten betroffener Personen gem. Art. 6 Abs. 1 lit. f. DSGVO auf Grundlage unserer berechtigten Interessen, z.B. wenn es sich um administrative Aufgaben oder Öffentlichkeitsarbeit handelt. <br>
          Die hierbei verarbeiteten Daten, die Art, der Umfang und der Zweck und die Erforderlichkeit ihrer Verarbeitung bestimmen sich nach dem zugrundeliegenden Vertragsverhältnis. Dazu gehören grundsätzlich Bestands- und Stammdaten der Personen (z.B., Name, Adresse, etc.), als auch die Kontaktdaten (z.B., E-Mailadresse, Telefon, etc.), die Vertragsdaten (z.B., in Anspruch genommene Leistungen, mitgeteilte Inhalte und Informationen, Namen von Kontaktpersonen) und sofern wir zahlungspflichtige Leistungen oder Produkte anbieten, Zahlungsdaten (z.B., Bankverbindung, Zahlungshistorie, etc.). <br>
          Wir löschen Daten, die zur Erbringung unserer satzungs- und geschäftsmäßigen Zwecke nicht mehr erforderlich sind. Dies bestimmt sich entsprechend der jeweiligen Aufgaben und vertraglichen Beziehungen. Im Fall geschäftlicher Verarbeitung bewahren wir die Daten so lange auf, wie sie zur Geschäftsabwicklung, als auch im Hinblick auf etwaige Gewährleistungs- oder Haftungspflichten relevant sein können. Die Erforderlichkeit der Aufbewahrung der Daten wird alle drei Jahre überprüft; im Übrigen gelten die gesetzlichen 
        </p>
        <p><b>Registrierfunktion</b></p>
        <p class="small">
          Nutzer können ein Nutzerkonto anlegen. Im Rahmen der Registrierung werden die erforderlichen Pflichtangaben den Nutzern mitgeteilt und auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO zu Zwecken der Bereitstellung des Nutzerkontos verarbeitet. Zu den verarbeiteten Daten gehören insbesondere die Login-Informationen (Name, Passwort sowie eine E-Mailadresse). Die im Rahmen der Registrierung eingegebenen Daten werden für die Zwecke der Nutzung des Nutzerkontos und dessen Zwecks verwendet. <br>
          Die Nutzer können über Informationen, die für deren Nutzerkonto relevant sind, wie z.B. technische Änderungen, per E-Mail informiert werden. Wenn Nutzer ihr Nutzerkonto gekündigt haben, werden deren Daten im Hinblick auf das Nutzerkonto, vorbehaltlich einer gesetzlichen Aufbewahrungspflicht, gelöscht. Es obliegt den Nutzern, ihre Daten bei erfolgter Kündigung vor dem Vertragsende zu sichern. Wir sind berechtigt, sämtliche während der Vertragsdauer gespeicherten Daten des Nutzers unwiederbringlich zu löschen. <br>
          Im Rahmen der Inanspruchnahme unserer Registrierungs- und Anmeldefunktionen sowie der Nutzung des Nutzerkontos, speichern wird die IP-Adresse und den Zeitpunkt der jeweiligen Nutzerhandlung. Die Speicherung erfolgt auf Grundlage unserer berechtigten Interessen, als auch der Nutzer an Schutz vor Missbrauch und sonstiger unbefugter Nutzung. Eine Weitergabe dieser Daten an Dritte erfolgt grundsätzlich nicht, außer sie ist zur Verfolgung unserer Ansprüche erforderlich oder es besteht hierzu besteht eine gesetzliche Verpflichtung gem. Art. 6 Abs. 1 lit. c. DSGVO. Die IP-Adressen werden spätestens nach 7 Tagen anonymisiert oder gelöscht.</p>
        <p><b>Kontaktaufnahme</b></p>
        <p class="small">
          Bei der Kontaktaufnahme mit uns (z.B. per Kontaktformular, E-Mail, Telefon oder via sozialer Medien) werden die Angaben des Nutzers zur Bearbeitung der Kontaktanfrage und deren Abwicklung gem. Art. 6 Abs. 1 lit. b. (im Rahmen vertraglicher-/vorvertraglicher Beziehungen), Art. 6 Abs. 1 lit. f. (andere Anfragen) DSGVO verarbeitet.. Die Angaben der Nutzer können in einem Customer-Relationship-Management System ("CRM System") oder vergleichbarer Anfragenorganisation gespeichert werden. <br>
          Wir löschen die Anfragen, sofern diese nicht mehr erforderlich sind. Wir überprüfen die Erforderlichkeit alle zwei Jahre; Ferner gelten die gesetzlichen Archivierungspflichten.
        </p>
        <p><b>Hosting und E-Mail-Versand</b></p>
        <p class="small">Die von uns in Anspruch genommenen Hosting-Leistungen dienen der Zurverfügungstellung der folgenden Leistungen: Infrastruktur- und Plattformdienstleistungen, Rechenkapazität, Speicherplatz und Datenbankdienste, E-Mail-Versand, Sicherheitsleistungen sowie technische Wartungsleistungen, die wir zum Zwecke des Betriebs dieses Onlineangebotes einsetzen. <br>
        Hierbei verarbeiten wir, bzw. unser Hostinganbieter Bestandsdaten, Kontaktdaten, Inhaltsdaten, Vertragsdaten, Nutzungsdaten, Meta- und Kommunikationsdaten von Kunden, Interessenten und Besuchern dieses Onlineangebotes auf Grundlage unserer berechtigten Interessen an einer effizienten und sicheren Zurverfügungstellung dieses Onlineangebotes gem. Art. 6 Abs. 1 lit. f DSGVO i.V.m. Art. 28 DSGVO (Abschluss Auftragsverarbeitungsvertrag).</p>
        <p><b>Erhebung von Zugriffsdaten und Logfiles</b></p>
        <p class="small">
          Wir, bzw. unser Hostinganbieter, erhebt auf Grundlage unserer berechtigten Interessen im Sinne des Art. 6 Abs. 1 lit. f. DSGVO Daten über jeden Zugriff auf den Server, auf dem sich dieser Dienst befindet (sogenannte Serverlogfiles). Zu den Zugriffsdaten gehören Name der abgerufenen Webseite, Datei, Datum und Uhrzeit des Abrufs, übertragene Datenmenge, Meldung über erfolgreichen Abruf, Browsertyp nebst Version, das Betriebssystem des Nutzers, Referrer URL (die zuvor besuchte Seite), IP-Adresse und der anfragende Provider. <br>
          Logfile-Informationen werden aus Sicherheitsgründen (z.B. zur Aufklärung von Missbrauchs- oder Betrugshandlungen) für die Dauer von maximal 7 Tagen gespeichert und danach gelöscht. Daten, deren weitere Aufbewahrung zu Beweiszwecken erforderlich ist, sind bis zur endgültigen Klärung des jeweiligen Vorfalls von der Löschung ausgenommen.</p>
        <p><b>Einbindung von Diensten und Inhalten Dritter</b></p>
        <p class="small">Wir setzen innerhalb unseres Onlineangebotes auf Grundlage unserer berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung und wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO) Inhalts- oder Serviceangebote von Drittanbietern ein, um deren Inhalte und Services, wie z.B. Videos oder Schriftarten einzubinden (nachfolgend einheitlich bezeichnet als “Inhalte”). <br>
Dies setzt immer voraus, dass die Drittanbieter dieser Inhalte, die IP-Adresse der Nutzer wahrnehmen, da sie ohne die IP-Adresse die Inhalte nicht an deren Browser senden könnten. Die IP-Adresse ist damit für die Darstellung dieser Inhalte erforderlich. Wir bemühen uns nur solche Inhalte zu verwenden, deren jeweilige Anbieter die IP-Adresse lediglich zur Auslieferung der Inhalte verwenden. Drittanbieter können ferner so genannte Pixel-Tags (unsichtbare Grafiken, auch als "Web Beacons" bezeichnet) für statistische oder Marketingzwecke verwenden. Durch die "Pixel-Tags" können Informationen, wie der Besucherverkehr auf den Seiten dieser Website ausgewertet werden. Die pseudonymen Informationen können ferner in Cookies auf dem Gerät der Nutzer gespeichert werden und unter anderem technische Informationen zum Browser und Betriebssystem, verweisende Webseiten, Besuchszeit sowie weitere Angaben zur Nutzung unseres Onlineangebotes enthalten, als auch mit solchen Informationen aus anderen Quellen verbunden werden.</p>
      </div>
    </modal>
  </div>
</template>

<script>

export default {
  name: 'Footer',
  data() {
    return {
      currentYear: new Date().getFullYear()
    }
  },
  methods: {
    showImpressum() {
      this.$modal.show('impressum-modal')
    },
    showPrivacy() {
      this.$modal.show('privacy-modal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/theme.scss";

p, div {
  text-align: center;

  @include tablet {
    text-align: left;
  }
}



.footer {
    padding: 6px 0px 20px 0px;
    background: darken($dark, 5%);
}

.legal {
    background: darken($dark, 15%);
    opacity: 0.8;
}

.border {
  border-top: 2px solid $light-0;
}

p {
  color: white;

  svg {
    color: $primary-0;
    margin-right: 10px;
  }

  .year {
    margin-right: 10px;
  }

  .title {
    margin-left: 10px;
  }
}

.legal {
  .entry {
    cursor: pointer;
    font-weight: 800;
  }

  .seperator {
    opacity: 0.7;
  }
}

.flex-row {
  display: flex;
  flex-wrap: wrap;

  .links {
    width: 100%;

    @include tablet {
      width: 40%;
    }
  }

  .links-others {
    width: 100%;

    @include tablet {
      width: 60%;
    }
  }
}

.other {
  .header {
    font-weight: 800;
    opacity: 0.8;
  }

  .link-list {
    a {
      color: $light-0;
      text-decoration: none;
      opacity: 0.5;
    }
    .link {
      margin-bottom: 10px;
    }
  }
}

.modal {
  padding: 10px 40px;

  h1 {
    color: $dark;
    font-size: 28px;
  }

  p {
    color: $dark;
    opacity: 0.8;
  }

  h2 {
    color: $dark;
    font-size: 20px;
    opacity: 0.9;
  }

  .small {
    font-size: small;
    text-align: justify;
  }
}

.impressum-modal, .privacy-modal {
  height: 500px;
  overflow-y: auto;
}

.social-media {

  @include tablet {
    float: right;
    margin-top: -50px;
  }

  a {
    color: #eaeaea;
    font-size: 32px;
    margin: 0px 8px;

    
    @include tablet {
      font-size: 28px;
    }


    &:hover {
      color: #fff;
    }
  }

  .seperator {
    color: #f2f2f2;
    font-size: 18px;
    position: relative;
    bottom: 6px;
    opacity: 0.4;
    user-select: none;

    @include tablet {
      bottom: 2px;
    }
  }

  margin-bottom: 12px;
}

.container {
  position: relative;
}

</style>
